import { CompanySettingsController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Cost accounting settings.
 * @example
 * ```html
 * <salaxy-cost-accounting-settings></salaxy-cost-accounting-settings>
 * ```
 */

export class CostAccountingSettings extends ComponentBase {

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = {
     /** Forced read only state */
     isReadOnlyForced: "<"
  };

  /** Uses the CompanySettingsController */
  public controller = CompanySettingsController;

  /** Default template is the view  */
  public defaultTemplate = "salaxy-components/settings/CostAccountingSettings.html";

}
